@if (loading) {
  <div class="page-loading">
    <span>
      <span></span>
    </span>
  </div>
}
<div class="my-ballots my-orders grid-layout">
  <div class="row clearfix max-width">
    <div class="small-12 columns account-row">
      <a (click)="navigate('/Users/my-profile')" title="">
        <span class="fa fa-fw fa-arrow-left"></span> Back to My Account
      </a>
    </div>
  </div>
  <div class="row clearfix max-width">
    <div class="small-12 columns header-row account-row">
      <h2>My Favourites</h2>
    </div>
  </div>
  @if (favourites || favourites.length > 0) {
    <product-list [items]="favourites"></product-list>
  }
</div>
